/* eslint-disable spaced-comment */
// helpers.js
import axios from 'axios'
import { i18n } from '../../src/plugins/i18n'

// Url all countries
const countriesUrl = `${process.env.VUE_APP_CABINET_V2_API_HOST_PROCESS}/countries?country=0`

export function getCurrentLanguage() {
	const language = localStorage.getItem('language')
	let currentLanguage = null

	if (language) {
		currentLanguage = language
	}

	return currentLanguage
}

export async function getCountries(headersString) {
	try {
		const result = await axios({
			method: 'GET',
			url: countriesUrl,
			headers: headersString,
		})
		const countries = result.data

		const language = getCurrentLanguage() || 'en'

		const countriesOptions = countries.map((country) => {
			const text =
				language === 'en' ? country.name : country[`name_${language}`]

			return {
				text,
				value: country.iso2,
				id: country.id,
			}
		})

		countriesOptions.sort((a, b) => a.text.localeCompare(b.text))

		return countriesOptions
	} catch (error) {
		return []
	}
}

// URL Countries
const baseApiUrl = process.env.VUE_APP_CABINET_V2_API_HOST_PROCESS

async function fetchCountries(url, headersString) {
	try {
		const result = await axios({
			method: 'GET',
			url,
			headers: headersString,
		})
		const countries = result.data

		const language = getCurrentLanguage() || 'en'

		const countriesOptions = countries.map((country) => {
			const text =
				language === 'en' ? country.name : country[`name_${language}`]

			return {
				text,
				value: country.iso2,
				id: country.id,
			}
		})

		countriesOptions.sort((a, b) => a.text.localeCompare(b.text))

		return countriesOptions
	} catch (error) {
		return []
	}
}

export function getCountriesExcluded(headersString) {
	const url = `${baseApiUrl}/countries?exclude_filter=1&access=1`
	return fetchCountries(url, headersString)
}

export function getCountriesFilter(headersString) {
	const url = `${baseApiUrl}/countries?access=1`
	return fetchCountries(url, headersString)
}

export async function getProvinces(headersString, countryId, countryName) {
	try {
		const result = await axios({
			method: 'GET',
			url: `${process.env.VUE_APP_CABINET_V2_API_HOST_PROCESS}/countries?country=${countryId}`,
			headers: headersString,
		})
		const provinces = result.data
		let provincesOptions = []
		if (provinces.length > 0) {
			provincesOptions = provinces.map((province) => ({
				text: province.name,
				value: province.name,
				id: province.id,
			}))
		} else {
			provincesOptions.push({
				text: countryName,
				value: countryName,
				id: 0,
			})
		}

		provincesOptions.sort((a, b) => {
			if (a.text.toLowerCase() < b.text.toLowerCase()) {
				return -1
			}
			if (a.text.toLowerCase() > b.text.toLowerCase()) {
				return 1
			}
			return 0
		})

		return provincesOptions
	} catch (error) {
		return []
	}
}

export async function getCities(
	headersString,
	countryId,
	provinceId,
	countryName,
	provinceName,
) {
	try {
		const result = await axios({
			method: 'GET',
			url: `${process.env.VUE_APP_CABINET_V2_API_HOST_PROCESS}/countries?country=${countryId}&state=${provinceId}`,
			headers: headersString,
		})
		const cities = result.data
		let citiesOptions = []
		if (cities.length > 0) {
			citiesOptions = cities.map((city) => ({
				text: city.name,
				value: city.name,
			}))
		} else if (provinceId === 0) {
			citiesOptions.push({
				text: countryName,
				value: countryName,
			})
		} else {
			citiesOptions.push({
				text: provinceName,
				value: provinceName,
			})
		}

		citiesOptions.sort((a, b) => {
			if (a.text.toLowerCase() < b.text.toLowerCase()) {
				return -1
			}
			if (a.text.toLowerCase() > b.text.toLowerCase()) {
				return 1
			}
			return 0
		})

		return citiesOptions
	} catch (error) {
		return []
	}
}

export const genders = [
	{ text: i18n.global.t('array.female'), value: 'female' },
	{ text: i18n.global.t('array.male'), value: 'male' },
	{ text: i18n.global.t('array.noBinary'), value: 'non-binary' },
	{ text: i18n.global.t('array.other'), value: 'other' },
	{ text: i18n.global.t('array.noAnswer'), value: 'prefer-not-to-answer' },
]

export const gendersMena = [
	{ text: i18n.global.t('array.female'), value: 'female' },
	{ text: i18n.global.t('array.male'), value: 'male' },
]

export const maritalStatus = [
	{ text: i18n.global.t('array.single'), value: 'single' },
	{ text: i18n.global.t('array.married'), value: 'married' },
	{ text: i18n.global.t('array.divorced'), value: 'divorced' },
	{ text: i18n.global.t('array.windowed'), value: 'windowed' },
	{ text: i18n.global.t('array.registered'), value: 'registered-partnership' },
]

export const maritalStatusMena = [
	{ text: i18n.global.t('array.single'), value: 'single' },
	{ text: i18n.global.t('array.married'), value: 'married' },
	{ text: i18n.global.t('array.divorced'), value: 'divorced' },
	{ text: i18n.global.t('array.windowed'), value: 'windowed' },
]

export const optionsTrading = [
	{ text: i18n.global.t('accounts.forex'), value: 'forex' },
	{ text: i18n.global.t('array.stocks'), value: 'stocks' },
	{ text: i18n.global.t('array.futures'), value: 'futures' },
]

export const optionsTradingMena = [
	{ text: i18n.global.t('accounts.forex'), value: 'forex' },
	{ text: i18n.global.t('array.stocks'), value: 'stocks' },
]

export const optionsCountryIndicative = [
	{ text: '+43', value: '+43', country: 'Austria' },
	{ text: '+30', value: '+30', country: 'Greece' },
	{ text: '+34', value: '+34', country: 'Spain' },
	{ text: '+52', value: '+52', country: 'Mexico' },
	{ text: '+54', value: '+54', country: 'Argentina' },
	{ text: '+55', value: '+55', country: 'Brazil' },
	{ text: '+57', value: '+57', country: 'Colombia' },
	{ text: '+51', value: '+51', country: 'Peru' },
	{ text: '+56', value: '+56', country: 'Chile' },
	{ text: '+593', value: '+593', country: 'Ecuador' },
	{ text: '+506', value: '+506', country: 'Costa Rica' },
	{ text: '+58', value: '+58', country: 'Venezuela' },
	{ text: '+1', value: '+1', country: 'United States' },
	{ text: '+213', value: '+213', country: 'Algeria' },
	{ text: '+61', value: '+61', country: 'Australia' },
	{ text: '+44', value: '+44', country: 'United Kingdom' },
	{ text: '+33', value: '+33', country: 'France' },
	{ text: '+49', value: '+49', country: 'Germany' },
	{ text: '+39', value: '+39', country: 'Italy' },
	{ text: '+81', value: '+81', country: 'Japan' },
	{ text: '+86', value: '+86', country: 'China' },
	{ text: '+91', value: '+91', country: 'India' },
	{ text: '+7', value: '+7', country: 'Russia' },
	{ text: '+27', value: '+27', country: 'South Africa' },
	{ text: '+62', value: '+62', country: 'Indonesia' },
	{ text: '+60', value: '+60', country: 'Malaysia' },
	{ text: '+66', value: '+66', country: 'Thailand' },
	{ text: '+65', value: '+65', country: 'Singapore' },
	{ text: '+63', value: '+63', country: 'Philippines' },
	{ text: '+84', value: '+84', country: 'Vietnam' },
	{ text: '+420', value: '+420', country: 'Czech Republic' },
	{ text: '+971', value: '+971', country: 'United Arab Emirates' },
	{ text: '+967', value: '+967', country: 'Yemen' },
	{ text: '+962', value: '+962', country: 'Jordan' },
	{ text: '+965', value: '+965', country: 'Kuwait' },
	{ text: '+961', value: '+961', country: 'Lebanon' },
	{ text: '+968', value: '+968', country: 'Oman' },
	{ text: '+974', value: '+974', country: 'Qatar' },
	{ text: '+963', value: '+963', country: 'Syria' },
	{ text: '+90', value: '+90', country: 'Turkey' },
	{ text: '+998', value: '+998', country: 'Uzbekistan' },
	{ text: '+993', value: '+993', country: 'Turkmenistan' },
	{ text: '+994', value: '+994', country: 'Azerbaijan' },
	{ text: '+995', value: '+995', country: 'Georgia' },
	{ text: '+374', value: '+374', country: 'Armenia' },
	{ text: '+996', value: '+996', country: 'Kyrgyzstan' },
	{ text: '+992', value: '+992', country: 'Tajikistan' },
	{ text: '+93', value: '+93', country: 'Afghanistan' },
	{ text: '+964', value: '+964', country: 'Iraq' },
	{ text: '+972', value: '+972', country: 'Israel' },
	{ text: '+973', value: '+973', country: 'Bahrain' },
	{ text: '+20', value: '+20', country: 'Egypt' },
	{ text: '+503', value: '+503', country: 'El Salvador' },
	{ text: '+240', value: '+240', country: 'Equatorial Guinea' },
	{ text: '+291', value: '+291', country: 'Eritrea' },
	{ text: '+372', value: '+372', country: 'Estonia' },
	{ text: '+268', value: '+268', country: 'Eswatini' },
	{ text: '+251', value: '+251', country: 'Ethiopia' },
	{ text: '+679', value: '+679', country: 'Fiji' },
	{ text: '+358', value: '+358', country: 'Finland' },
	{ text: '+689', value: '+689', country: 'French Polynesia' },
	{ text: '+241', value: '+241', country: 'Gabon' },
	{ text: '+220', value: '+220', country: 'The Gambia' },
	{ text: '+233', value: '+233', country: 'Ghana' },
	{ text: '+1-473', value: '+1-473', country: 'Grenada' },
	{ text: '+502', value: '+502', country: 'Guatemala' },
	{ text: '+224', value: '+224', country: 'Guinea' },
	{ text: '+245', value: '+245', country: 'Guinea-Bissau' },
	{ text: '+592', value: '+592', country: 'Guyana' },
	{ text: '+509', value: '+509', country: 'Haiti' },
	{ text: '+504', value: '+504', country: 'Honduras' },
	{ text: '+852', value: '+852', country: 'Hong Kong' },
	{ text: '+36', value: '+36', country: 'Hungary' },
	{ text: '+354', value: '+354', country: 'Iceland' },
	{ text: '+98', value: '+98', country: 'Iran' },
	{ text: '+353', value: '+353', country: 'Ireland' },
	{ text: '+1-876', value: '+1-876', country: 'Jamaica' },
	{ text: '+7', value: '+7', country: 'Kazakhstan' },
	{ text: '+254', value: '+254', country: 'Kenya' },
	{ text: '+686', value: '+686', country: 'Kiribati' },
	{ text: '+82', value: '+82', country: 'Korea, South' },
	{ text: '+856', value: '+856', country: 'Laos' },
	{ text: '+371', value: '+371', country: 'Latvia' },
	{ text: '+266', value: '+266', country: 'Lesotho' },
	{ text: '+423', value: '+423', country: 'Liechtenstein' },
	{ text: '+370', value: '+370', country: 'Lithuania' },
	{ text: '+352', value: '+352', country: 'Luxembourg' },
	{ text: '+261', value: '+261', country: 'Madagascar' },
	{ text: '+265', value: '+265', country: 'Malawi' },
	{ text: '+960', value: '+960', country: 'Maldives' },
	{ text: '+223', value: '+223', country: 'Mali' },
	{ text: '+356', value: '+356', country: 'Malta' },
	{ text: '+692', value: '+692', country: 'Marshall Islands' },
	{ text: '+222', value: '+222', country: 'Mauritania' },
	{ text: '+230', value: '+230', country: 'Mauritius' },
	{ text: '+691', value: '+691', country: 'Micronesia, Federated States of' },
	{ text: '+373', value: '+373', country: 'Moldova' },
	{ text: '+377', value: '+377', country: 'Monaco' },
	{ text: '+976', value: '+976', country: 'Mongolia' },
	{ text: '+382', value: '+382', country: 'Montenegro' },
	{ text: '+212', value: '+212', country: 'Morocco' },
	{ text: '+258', value: '+258', country: 'Mozambique' },
	{ text: '+95', value: '+95', country: 'Myanmar (Burma)' },
	{ text: '+264', value: '+264', country: 'Namibia' },
	{ text: '+674', value: '+674', country: 'Nauru' },
	{ text: '+977', value: '+977', country: 'Nepal' },
	{ text: '+31', value: '+31', country: 'Netherlands' },
	{ text: '+64', value: '+64', country: 'New Zealand' },
	{ text: '+505', value: '+505', country: 'Nicaragua' },
	{ text: '+227', value: '+227', country: 'Niger' },
	{ text: '+234', value: '+234', country: 'Nigeria' },
	{ text: '+389', value: '+389', country: 'North Macedonia' },
	{ text: '+47', value: '+47', country: 'Norway' },
	{ text: '+92', value: '+92', country: 'Pakistan' },
	{ text: '+680', value: '+680', country: 'Palau' },
	{ text: '+507', value: '+507', country: 'Panama' },
	{ text: '+675', value: '+675', country: 'Papua New Guinea' },
	{ text: '+595', value: '+595', country: 'Paraguay' },
	{ text: '+48', value: '+48', country: 'Poland' },
	{ text: '+351', value: '+351', country: 'Portugal' },
	{ text: '+40', value: '+40', country: 'Romania' },
	{ text: '+250', value: '+250', country: 'Rwanda' },
	{ text: '+1-869', value: '+1-869', country: 'Saint Kitts and Nevis' },
	{ text: '+1-758', value: '+1-758', country: 'Saint Lucia' },
	{ text: '+81', value: '+81', country: 'Japan' },
	{
		text: '+1-784',
		value: '+1-784',
		country: 'Saint Vincent and the Grenadines',
	},
	{ text: '+685', value: '+685', country: 'Samoa' },
	{ text: '+378', value: '+378', country: 'San Marino' },
	{ text: '+239', value: '+239', country: 'Sao Tome and Principe' },
	{ text: '+966', value: '+966', country: 'Saudi Arabia' },
	{ text: '+221', value: '+221', country: 'Senegal' },
	{ text: '+381', value: '+381', country: 'Serbia' },
	{ text: '+248', value: '+248', country: 'Seychelles' },
	{ text: '+421', value: '+421', country: 'Slovakia' },
	{ text: '+386', value: '+386', country: 'Slovenia' },
	{ text: '+677', value: '+677', country: 'Solomon Islands' },
	{ text: '+252', value: '+252', country: 'Somalia' },
	{ text: '+94', value: '+94', country: 'Sri Lanka' },
	{ text: '+597', value: '+597', country: 'Suriname' },
	{ text: '+46', value: '+46', country: 'Sweden' },
	{ text: '+41', value: '+41', country: 'Switzerland' },
	{ text: '+886', value: '+886', country: 'Taiwan' },
	{ text: '+255', value: '+255', country: 'Tanzania' },
	{ text: '+66', value: '+66', country: 'Thailand' },
	{ text: '+228', value: '+228', country: 'Togo' },
	{ text: '+676', value: '+676', country: 'Tonga' },
	{ text: '+1-868', value: '+1-868', country: 'Trinidad and Tobago' },
	{ text: '+216', value: '+216', country: 'Tunisia' },
	{ text: '+688', value: '+688', country: 'Tuvalu' },
	{ text: '+256', value: '+256', country: 'Uganda' },
	{ text: '+380', value: '+380', country: 'Ukraine' },
	{ text: '+598', value: '+598', country: 'Uruguay' },
	{ text: '+678', value: '+678', country: 'Vanuatu' },
	{ text: '+379', value: '+379', country: 'Vatican City' },
	{ text: '+260', value: '+260', country: 'Zambia' },
	{ text: '+263', value: '+263', country: 'Zimbabwe' },
]

export const optionsCurrencyForex = [
	{ text: 'USD', value: 'usd' },
	{ text: 'EUR', value: 'eur' },
	{ text: 'JPY', value: 'jpy' },
	{ text: 'AUD', value: 'aud' },
	{ text: 'CAD', value: 'cad' },
	{ text: 'CHF', value: 'chf' },
	{ text: 'GBP', value: 'gbp' },
	{ text: 'MXN', value: 'mxn' },
]

export const optionsCurrencyForexMena = [
	{ text: i18n.global.t('array.usd'), value: 'usd' },
	{ text: i18n.global.t('array.eur'), value: 'eur' },
	{ text: i18n.global.t('array.gbp'), value: 'gbp' },
]

export const optionsCurrencyOther = [
	{ text: i18n.global.t('array.usd'), value: 'usd' },
]

export const optionsPlatformForex = [
	{ text: i18n.global.t('accounts.mt4'), value: 'mt4' },
	{ text: i18n.global.t('accounts.mt5'), value: 'mt5' },
	{ text: 'cTrader', value: 'ctrader' },
]

export const optionsPlatformForexMena = [
	{ text: i18n.global.t('accounts.mt4'), value: 'mt4' },
	{ text: i18n.global.t('accounts.mt5'), value: 'mt5' },
]

export const optionsPlatformStockJapan = [
	{ text: i18n.global.t('accounts.mt5'), value: 'mt5' },
	{ text: 'API/FIX', value: 'api-fix' },
]

export const optionsPlatformStock = [
	{ text: i18n.global.t('accounts.mt5'), value: 'mt5' },
	{ text: 'Sterling', value: 'sterling' },
	{ text: 'Lightspeed', value: 'lightspeed' },
	{ text: 'Takion', value: 'takion' },
	{ text: 'DAS', value: 'das' },
	{ text: 'API/FIX', value: 'api-fix' },
]

export const optionsPlatformFutures = [
	// { text: i18n.global.t('accounts.mt5'), value: 'mt5' }, INHABILITADO
	{ text: 'CQG', value: 'cqg' },
	{ text: 'API/FIX', value: 'api-fix' },
]

export const optionsPlatformFuturesJapan = [
	{ text: 'API/FIX', value: 'api-fix' },
]

export const optionsPlatformStockMena = [
	{ text: i18n.global.t('accounts.mt5'), value: 'mt5' },
]

export const optionsType = [
	{ text: 'ILC', value: 'ilc' },
	{ text: 'XLev', value: 'xlev' },
]
export const optionsCtraderType = [{ text: 'ILC', value: 'ilc' }]

export const optionsTypeCTrader = [{ text: 'ILC', value: 'ilc' }]

export const optionsEmploymentStatus = [
	{ text: i18n.global.t('array.employed'), value: 'employed' },
	{ text: i18n.global.t('array.selfEmployed'), value: 'self-employed' },
	{ text: i18n.global.t('array.retired'), value: 'retired' },
	{ text: i18n.global.t('array.unemployed'), value: 'unemployed' },
]

export const optionsIndustry = [
	{
		text: i18n.global.t('array.aerospaceAndDefense'),
		value: 'aerospace and defense',
	},
	{ text: i18n.global.t('array.agriculture'), value: 'agriculture' },
	{ text: i18n.global.t('array.automotive'), value: 'automotive' },
	{ text: i18n.global.t('array.construction'), value: 'construction' },
	{ text: i18n.global.t('array.consulting'), value: 'consulting' },
	{ text: i18n.global.t('array.eCommerce'), value: 'e commerce' },
	{ text: i18n.global.t('array.education'), value: 'education' },
	{
		text: i18n.global.t('array.energyAndUtilities'),
		value: 'energy and utilities',
	},
	{
		text: i18n.global.t('array.entertainmentAndMedia'),
		value: 'entertainment and media',
	},
	{
		text: i18n.global.t('array.fashionAndApparel'),
		value: 'fashion and apparel',
	},
	{
		text: i18n.global.t('array.financeAndBanking'),
		value: 'finance and banking',
	},
	{ text: i18n.global.t('array.foodAndBeverage'), value: 'food and beverage' },
	{ text: i18n.global.t('array.government'), value: 'government' },
	{
		text: i18n.global.t('array.healthAndWellness'),
		value: 'health and wellness',
	},
	{ text: i18n.global.t('array.hospitality'), value: 'hospitality' },
	{ text: i18n.global.t('array.itTechnology'), value: 'it technology' },
	{ text: i18n.global.t('array.legalServices'), value: 'legal services' },
	{ text: i18n.global.t('array.manufacturing'), value: 'manufacturing' },
	{
		text: i18n.global.t('array.marketingAndAdvertising'),
		value: 'marketing and advertising',
	},
	{
		text: i18n.global.t('array.nonProfitCharity'),
		value: 'non profit charity',
	},
	{ text: i18n.global.t('array.realEstate'), value: 'real estate' },
	{ text: i18n.global.t('array.retail'), value: 'retail' },
	{ text: i18n.global.t('array.serviceProvider'), value: 'service provider' },
	{
		text: i18n.global.t('array.telecommunications'),
		value: 'telecommunications',
	},
	{
		text: i18n.global.t('array.transportationAndLogistics'),
		value: 'transportation and logistics',
	},
	{ text: i18n.global.t('array.other'), value: 'other' },
]

export const optionsEmploymentType = [
	{ text: i18n.global.t('array.apprenticeship'), value: 'apprenticeship' },
	{ text: i18n.global.t('array.casual'), value: 'casual' },
	{ text: i18n.global.t('array.contractual'), value: 'contractual' },
	{ text: i18n.global.t('array.freelance'), value: 'freelance' },
	{ text: i18n.global.t('array.fullTime'), value: 'full time' },
	{ text: i18n.global.t('array.internship'), value: 'internship' },
	{ text: i18n.global.t('array.onDemand'), value: 'on demand' },
	{ text: i18n.global.t('array.other'), value: 'other' },
	{
		text: i18n.global.t('array.outsourcedOrOffshore'),
		value: 'outsourced or offshore',
	},
	{ text: i18n.global.t('array.partTime'), value: 'part time' },
	{ text: i18n.global.t('array.permanent'), value: 'permanent' },
	{ text: i18n.global.t('array.projectBased'), value: 'project based' },
	{ text: i18n.global.t('array.regular'), value: 'regular' },
	{ text: i18n.global.t('array.seasonal'), value: 'seasonal' },
	{ text: i18n.global.t('array.temporary'), value: 'temporary' },
	{ text: i18n.global.t('array.volunteer'), value: 'volunteer' },
]

export const optionsBusinessType = [
	{
		text: i18n.global.t('array.benefitCorporation'),
		value: 'benefit corporation',
	},
	{ text: i18n.global.t('array.cooperative'), value: 'cooperative' },
	{
		text: i18n.global.t('array.cooperativeCorporation'),
		value: 'cooperative corporation',
	},
	{ text: i18n.global.t('array.corporation'), value: 'corporation' },
	{
		text: i18n.global.t('array.familyOwnedBusiness'),
		value: 'family-owned business',
	},
	{ text: i18n.global.t('array.franchise'), value: 'franchise' },
	{ text: i18n.global.t('array.holdingCompany'), value: 'holding company' },
	{ text: i18n.global.t('array.jointVenture'), value: 'joint venture' },
	{
		text: i18n.global.t('array.llc'),
		value: 'limited liability company (llc)',
	},
	{
		text: i18n.global.t('array.lllp'),
		value: 'limited liability limited partnership (lllp)',
	},
	{
		text: i18n.global.t('array.llp'),
		value: 'limited liability partnership (llp)',
	},
	{ text: i18n.global.t('array.lp'), value: 'limited partnership (lp)' },
	{
		text: i18n.global.t('array.nonprofitOrganization'),
		value: 'nonprofit organization',
	},
	{ text: i18n.global.t('array.partnership'), value: 'partnership' },
	{
		text: i18n.global.t('array.privateEquityFirm'),
		value: 'private equity firm',
	},
	{
		text: i18n.global.t('array.professionalCorporation'),
		value: 'professional corporation (pc)',
	},
	{
		text: i18n.global.t('array.publiclyTradedCompany'),
		value: 'publicly traded company',
	},
	{ text: i18n.global.t('array.sCorporation'), value: 's corporation' },
	{ text: i18n.global.t('array.socialEnterprise'), value: 'social enterprise' },
	{
		text: i18n.global.t('array.soleProprietorship'),
		value: 'sole proprietorship',
	},
]

export const idDocumentOpt = [
	{ text: i18n.global.t('array.passport'), value: 'passport' },
	{ text: i18n.global.t('array.identityCard'), value: 'identityCard' },
	{ text: i18n.global.t('array.residencePermit'), value: 'residencePermit' },
	{ text: i18n.global.t('array.driversLicense'), value: 'driverLicense' },
]

export const optionsBusiness = [
	{
		text: i18n.global.t('array.benefitCorporation'),
		value: 'benefit corporation b corp',
	},
	{ text: i18n.global.t('array.cooperative'), value: 'cooperative' },
	{
		text: i18n.global.t('array.cooperativeCorporation'),
		value: 'cooperative corporation',
	},
	{ text: i18n.global.t('array.corporation'), value: 'corporation' },
	{
		text: i18n.global.t('array.familyOwnedBusiness'),
		value: 'family owned business',
	},
	{ text: i18n.global.t('array.franchise'), value: 'franchise' },
	{ text: i18n.global.t('array.holdingCompany'), value: 'holding company' },
	{ text: i18n.global.t('array.jointVenture'), value: 'joint venture' },
	{
		text: i18n.global.t('array.limitedLiabilityCompany'),
		value: 'limited liability company llc',
	},
	{
		text: i18n.global.t('array.limitedLiabilityLimitedPartnership'),
		value: 'limited liability limited partnership lllp',
	},
	{
		text: i18n.global.t('array.limitedLiabilityPartnership'),
		value: 'limited liability partnership llp',
	},
	{
		text: i18n.global.t('array.limitedPartnership'),
		value: 'limited partnership lp',
	},
	{
		text: i18n.global.t('array.nonprofitOrganization'),
		value: 'nonprofit organization',
	},
	{ text: i18n.global.t('array.partnership'), value: 'partnership' },
	{
		text: i18n.global.t('array.privateEquityFirm'),
		value: 'private equity firm',
	},
	{
		text: i18n.global.t('array.professionalCorporation'),
		value: 'professional corporation pc',
	},
	{
		text: i18n.global.t('array.publiclyTradedCompany'),
		value: 'publicly traded company',
	},
	{ text: i18n.global.t('array.sCorporation'), value: 's corporation' },
	{ text: i18n.global.t('array.socialEnterprise'), value: 'social enterprise' },
	{
		text: i18n.global.t('array.soleProprietorship'),
		value: 'sole proprietorship',
	},
]

export const optionsAnnualIncome = [
	{ text: i18n.global.t('array.below25'), value: 'Below $25,000 USD' },
	{
		text: i18n.global.t('array.between50'),
		value: 'Between $25,000 USD - $50,000 USD',
	},
	{
		text: i18n.global.t('array.between100'),
		value: 'Between $50,000 USD - $100,000 USD',
	},
	{ text: i18n.global.t('array.over100'), value: 'Over $100,000 USD' },
]

export const optionsAnnualIncomeCompany = [
	{ text: i18n.global.t('array.below50mil'), value: 'Less than $50,000 USD' },
	{
		text: i18n.global.t('array.between100mil'),
		value: 'Between $50,000 USD - $100,000 USD',
	},
	{
		text: i18n.global.t('array.between500mil'),
		value: 'Between $100,000 USD - $500,000 USD',
	},
	{
		text: i18n.global.t('array.between1000mill'),
		value: 'Between $500,000 USD - $1.000,000 USD',
	},
	{ text: i18n.global.t('array.over1000mill'), value: 'Over $1.000,000 USD' },
]

export const radioOptions = [
	{ text: i18n.global.t('array.yes'), value: true },
	{ text: i18n.global.t('array.no'), value: false },
]

export const originAssets = [
	{
		text: i18n.global.t('array.savingsFromSalary'),
		value: 'savings from salary',
	},
	{ text: i18n.global.t('array.governmentAid'), value: 'government aid' },
	{ text: i18n.global.t('array.sale'), value: 'sale' },
	{
		text: i18n.global.t('array.investmentsDividends'),
		value: 'investments dividends',
	},
	{
		text: i18n.global.t('array.incomeFromATrust'),
		value: 'income from a trust',
	},
	{ text: i18n.global.t('array.letting'), value: 'letting' },
	{ text: i18n.global.t('array.inheritance'), value: 'inheritance' },
	{ text: i18n.global.t('array.donation'), value: 'donation' },
	{ text: i18n.global.t('array.loan'), value: 'loan' },
	{
		text: i18n.global.t('array.incomeFromSelfEmployment'),
		value: 'income from self employment',
	},
	{
		text: i18n.global.t('array.parentsPartnerOrOther'),
		value: 'parents partner or other',
	},
	{ text: i18n.global.t('array.relativeSupport'), value: 'relative support' },
	{ text: i18n.global.t('array.other'), value: 'other' },
]

export const purposeAccount = [
	{ text: i18n.global.t('array.hedging'), value: 'hedging' },
	{ text: i18n.global.t('array.speculation'), value: 'speculation' },
	{
		text: i18n.global.t('array.longTermInvesting'),
		value: 'long term investing',
	},
	{
		text: i18n.global.t('array.proprietaryTrading'),
		value: 'Proprietary trading',
	},
	{ text: i18n.global.t('array.other'), value: 'other' },
]

export const taxPurposesOpt = [
	{ label: i18n.global.t('array.yes'), value: true, id: '1' },
	{ label: i18n.global.t('array.no'), value: false, id: '2' },
]

export const politicalExposedOtp = [
	{ label: i18n.global.t('array.yes'), value: true, id: '3' },
	{ label: i18n.global.t('array.no'), value: false, id: '4' },
]

export const representThisCompany = [
	{ label: i18n.global.t('array.yes'), value: true, id: '1' },
	{ label: i18n.global.t('array.no'), value: false, id: '2' },
]

export const radioSignature = [
	{ label: i18n.global.t('array.drawSignature'), value: 'draw', id: '1' },
	{ label: i18n.global.t('array.uploadSignature'), value: 'upload', id: '2' },
]

export const bankruptciesOpt = [
	{ label: i18n.global.t('array.yes'), value: true, id: '1' },
	{ label: i18n.global.t('array.no'), value: false, id: '2' },
]

export const yearsTrading = [
	{ text: i18n.global.t('array.neverTraded'), value: 'I have never traded' },
	{ text: i18n.global.t('array.zeroToFiveYears'), value: '0-5 years' },
	{ text: i18n.global.t('array.sixToTenYears'), value: '6-10 years' },
	{ text: i18n.global.t('array.overTenYears'), value: 'Over 10 years' },
]

export const tradingVolumen = [
	{ text: i18n.global.t('array.neverTraded'), value: 'I have never traded' },
	{ text: i18n.global.t('array.below50K'), value: 'Below $50,000 USD' },
	{
		text: i18n.global.t('array.between50KTo100K'),
		value: 'Between $50,000 USD - $100,000 USD',
	},
	{
		text: i18n.global.t('array.between100KTo500K'),
		value: 'Between $100,000 USD - $500,000 USD',
	},
	{ text: i18n.global.t('array.over500K'), value: 'Over $500,000' },
]

export const oftenTrade = [
	{ text: i18n.global.t('array.neverTraded'), value: 'I have never traded' },
	{ text: i18n.global.t('array.daily'), value: 'Daily' },
	{ text: i18n.global.t('array.weekly'), value: 'Weekly' },
	{ text: i18n.global.t('array.monthly'), value: 'Monthly' },
	{ text: i18n.global.t('array.quarterly'), value: 'Quarterly' },
	{ text: i18n.global.t('array.semiAnnually'), value: 'Semi-annually' },
]

export const ProofResidenceOpt = [
	{ text: i18n.global.t('array.utilityBill'), value: 'utilityBill' },
	{ text: i18n.global.t('array.bankStatement'), value: 'bankStatement' },
	{
		text: i18n.global.t('array.certificateResidency'),
		value: 'residencyCertificate',
	},
]
export const ProofResidenceCompanyOpt = [
	{
		text: i18n.global.t('array.utilityBill'),
		value: 'corporateDocProofOfAddressUtilityBill',
	},
	{
		text: i18n.global.t('array.bankStatement'),
		value: 'corporateDocProofOfAddressBankStatement',
	},
	{
		text: i18n.global.t('array.certificateResidency'),
		value: 'corporateDocProofOfAddressResidencyCertificate',
	},
]

export const listAcknowledgement = [
	{
		label: i18n.global.t('array.clientAgreement'),
		url: 'https://documents-tvmarkets.s3.us-west-1.amazonaws.com/01_Client+Agreement.pdf',
	},
	{
		label: i18n.global.t('array.electronicTradingAgreement'),
		url: 'https://documents-tvmarkets.s3.us-west-1.amazonaws.com/02_Electronic+trading+agreement.pdf',
	},
	{
		label: i18n.global.t('array.riskDisclosure'),
		url: 'https://documents-tvmarkets.s3.us-west-1.amazonaws.com/03_+Risk+Disclosure.pdf',
	},
	{
		label: i18n.global.t('array.privacyPolicy'),
		url: 'https://documents-tvmarkets.s3.us-west-1.amazonaws.com/04_+Privacy+Policy.pdf',
	},
	{
		label: i18n.global.t('array.consentToDelivery'),
		url: 'https://documents-tvmarkets.s3.us-west-1.amazonaws.com/05_+Consent+to+Delivery+of+Statements+by+Electronic+Media.pdf',
	},
	{
		label: i18n.global.t('array.commissionAgreement'),
		url: 'https://documents-tvmarkets.s3.us-west-1.amazonaws.com/06_+Commission+Agreement.pdf',
	},
	{
		label: i18n.global.t('array.termsAndConditions'),
		url: 'https://documents-tvmarkets.s3.us-west-1.amazonaws.com/07_Terms+and+conditions.pdf',
	},
	{
		label: i18n.global.t('array.termsAndConditions'),
		url: 'https://documents-tvmarkets.s3.us-west-1.amazonaws.com/07_Terms+and+conditions.pdf',
	},
]

export const listAcknowledgementMena = [
	{
		label: i18n.global.t('array.clientAgreement'),
		url: 'https://documents-tvmarkets.s3.us-west-1.amazonaws.com/01_Client+Agreement.pdf',
	},
	{
		label: i18n.global.t('array.electronicTradingAgreement'),
		url: 'https://documents-tvmarkets.s3.us-west-1.amazonaws.com/02_Electronic+trading+agreement.pdf',
	},
	{
		label: i18n.global.t('array.riskDisclosure'),
		url: 'https://documents-tvmarkets.s3.us-west-1.amazonaws.com/03_+Risk+Disclosure.pdf',
	},
	{
		label: i18n.global.t('array.privacyPolicy'),
		url: 'https://documents-tvmarkets.s3.us-west-1.amazonaws.com/04_+Privacy+Policy.pdf',
	},
	{
		label: i18n.global.t('array.consentToDelivery'),
		url: 'https://documents-tvmarkets.s3.us-west-1.amazonaws.com/05_+Consent+to+Delivery+of+Statements+by+Electronic+Media.pdf',
	},
	{
		label: i18n.global.t('array.commissionAgreement'),
		url: 'https://documents-tvmarkets.s3.us-west-1.amazonaws.com/06_+Commission+Agreement.pdf',
	},
	{
		label: i18n.global.t('array.termsAndConditions'),
		url: 'https://documents-tvmarkets.s3.us-west-1.amazonaws.com/07_Terms+and+conditions.pdf',
	},
]
export const listAcknowledgementJoint = [
	{
		label: i18n.global.t('array.clientAgreement'),
		url: 'https://documents-tvmarkets.s3.us-west-1.amazonaws.com/01_Client+Agreement.pdf',
	},
	{
		label: i18n.global.t('array.electronicTradingAgreement'),
		url: 'https://documents-tvmarkets.s3.us-west-1.amazonaws.com/02_Electronic+trading+agreement.pdf',
	},
	{
		label: i18n.global.t('array.riskDisclosure'),
		url: 'https://documents-tvmarkets.s3.us-west-1.amazonaws.com/03_+Risk+Disclosure.pdf',
	},
	{
		label: i18n.global.t('array.privacyPolicy'),
		url: 'https://documents-tvmarkets.s3.us-west-1.amazonaws.com/04_+Privacy+Policy.pdf',
	},
	{
		label: i18n.global.t('array.consentToDelivery'),
		url: 'https://documents-tvmarkets.s3.us-west-1.amazonaws.com/05_+Consent+to+Delivery+of+Statements+by+Electronic+Media.pdf',
	},
	{
		label: i18n.global.t('array.commissionAgreement'),
		url: 'https://documents-tvmarkets.s3.us-west-1.amazonaws.com/06_+Commission+Agreement.pdf',
	},
	{
		label: i18n.global.t('array.termsAndConditions'),
		url: 'https://documents-tvmarkets.s3.us-west-1.amazonaws.com/07_Terms+and+conditions.pdf',
	},
	{
		label: i18n.global.t('array.swapFree'),
		url: 'https://documents-tvmarkets.s3.us-west-1.amazonaws.com/27_+Swap+Free+Acknowledgement.pdf',
	},
]

export const listAcknowledgementIB = [
	{
		label: i18n.global.t('array.ibClientAgreement'),
		url: 'https://documents-tvmarkets.s3.us-west-1.amazonaws.com/01_IBClient+Agreement.pdf',
	},
	{
		label: i18n.global.t('array.electronicTradingAgreement'),
		url: 'https://documents-tvmarkets.s3.us-west-1.amazonaws.com/02_Electronic+trading+agreement.pdf',
	},
	{
		label: i18n.global.t('array.riskDisclosure'),
		url: 'https://documents-tvmarkets.s3.us-west-1.amazonaws.com/03_+Risk+Disclosure.pdf',
	},
	{
		label: i18n.global.t('array.privacyPolicy'),
		url: 'https://documents-tvmarkets.s3.us-west-1.amazonaws.com/04_+Privacy+Policy.pdf',
	},
	{
		label: i18n.global.t('array.consentToDelivery'),
		url: 'https://documents-tvmarkets.s3.us-west-1.amazonaws.com/05_+Consent+to+Delivery+of+Statements+by+Electronic+Media.pdf',
	},
	{
		label: i18n.global.t('array.termsAndConditions'),
		url: 'https://documents-tvmarkets.s3.us-west-1.amazonaws.com/07_Terms+and+conditions.pdf',
	},
]

export const listAcknowledgementIBWithTradingAccount = [
	{
		label: i18n.global.t('array.ibClientAgreement'),
		url: 'https://documents-tvmarkets.s3.us-west-1.amazonaws.com/01_IBClient+Agreement.pdf',
	},
	{
		label: i18n.global.t('array.tradingAgreement'),
		url: 'https://documents-tvmarkets.s3.us-west-1.amazonaws.com/01_Client+Agreement+EN+LATAM.pdf',
	},
	{
		label: i18n.global.t('array.electronicTradingAgreement'),
		url: 'https://documents-tvmarkets.s3.us-west-1.amazonaws.com/02_Electronic+trading+agreement.pdf',
	},
	{
		label: i18n.global.t('array.riskDisclosure'),
		url: 'https://documents-tvmarkets.s3.us-west-1.amazonaws.com/03_+Risk+Disclosure.pdf',
	},
	{
		label: i18n.global.t('array.privacyPolicy'),
		url: 'https://documents-tvmarkets.s3.us-west-1.amazonaws.com/04_+Privacy+Policy.pdf',
	},
	{
		label: i18n.global.t('array.consentToDelivery'),
		url: 'https://documents-tvmarkets.s3.us-west-1.amazonaws.com/05_+Consent+to+Delivery+of+Statements+by+Electronic+Media.pdf',
	},
	{
		label: i18n.global.t('array.termsAndConditions'),
		url: 'https://documents-tvmarkets.s3.us-west-1.amazonaws.com/07_Terms+and+conditions.pdf',
	},
]

export const accountsOptions = [
	{ label: i18n.global.t('array.live'), value: true, id: 'live' },
	{ label: i18n.global.t('array.demo'), value: false, id: 'demo' },
]

export const optionsClientSize = [
	{ text: '0–15 clients', value: '0-15' },
	{ text: '16–50 clients', value: '16-50' },
	{ text: '51–200 clients', value: '51-200' },
	{ text: '201–500 clients', value: '201-500' },
	{ text: 'Over 500 clients', value: '500+' },
]

export const optionsSourcesClient = [
	{
		text: 'Digital marketing strategies (mailing, social media, SEO...)',
		value: 'digital',
	},
	{ text: 'Friends and family', value: 'friends_family' },
	{
		text: 'Networking strategies (affiliate marketing, events, webinars...)',
		value: 'networking',
	},
	{ text: 'Referral programs', value: 'referral' },
	{ text: 'Traditional marketing (phone calls, SMS...)', value: 'traditional' },
]

export const optionsPlatformOffer = [
	{ text: i18n.global.t('accounts.mt4'), value: 'mt4' },
	{ text: i18n.global.t('accounts.mt5'), value: 'mt5' },
	{ text: 'cTrader', value: 'ctrader' },
	{ text: 'Takion', value: 'takion' },
	{ text: 'Lightspeed', value: 'lightspeed' },
	{ text: 'Sterling', value: 'sterling' },
	{ text: 'DAS', value: 'das' },
	{ text: 'CQG', value: 'cqg' },
]

export const optionsComplaintsPastTwoYears = [
	{ text: i18n.global.t('brokerDetails.complaintsOption1'), value: '1-5' },
	{ text: i18n.global.t('brokerDetails.complaintsOption2'), value: '6-10' },
	{
		text: i18n.global.t('brokerDetails.complaintsOption3'),
		value: 'over-10',
	},
]

export const optionsNatureOfComplaints = [
	{
		text: i18n.global.t('brokerDetails.natureOption1'),
		value: 'unsatisfactory-customer-service',
	},
	{
		text: i18n.global.t('brokerDetails.natureOption2'),
		value: 'delays-errors-trading-execution',
	},
	{
		text: i18n.global.t('brokerDetails.natureOption3'),
		value: 'unauthorized-trades',
	},
	{
		text: i18n.global.t('brokerDetails.natureOption4'),
		value: 'mishandling-accounts',
	},
	{
		text: i18n.global.t('brokerDetails.natureOption5'),
		value: 'misleading-information',
	},
	{
		text: i18n.global.t('brokerDetails.natureOption6'),
		value: 'compliance-regulatory-issues',
	},
	{
		text: i18n.global.t('brokerDetails.natureOption7'),
		value: 'disputes-financial-transactions',
	},
	{
		text: i18n.global.t('brokerDetails.natureOption8'),
		value: 'technical-issues-trading-platforms',
	},
	{
		text: i18n.global.t('brokerDetails.natureOption9'),
		value: 'performance-investment-advice',
	},
	{
		text: i18n.global.t('brokerDetails.natureOption10'),
		value: 'security-vulnerabilities',
	},
	{ text: i18n.global.t('brokerDetails.natureOption11'), value: 'others' },
]

export const optionsDisciplinaryActions = [
	{ text: i18n.global.t('brokerDetails.actionOption1'), value: 'warning' },
	{ text: i18n.global.t('brokerDetails.actionOption2'), value: 'fines' },
	{
		text: i18n.global.t('brokerDetails.actionOption3'),
		value: 'restrictions-operations',
	},
	{
		text: i18n.global.t('brokerDetails.actionOption4'),
		value: 'revocation-license',
	},
	{
		text: i18n.global.t('brokerDetails.actionOption5'),
		value: 'suspension-license',
	},
	{
		text: i18n.global.t('brokerDetails.actionOption6'),
		value: 'additional-training',
	},
	{
		text: i18n.global.t('brokerDetails.actionOption7'),
		value: 'changes-policies',
	},
	{
		text: i18n.global.t('brokerDetails.actionOption8'),
		value: 'restitution-compensation',
	},
	{
		text: i18n.global.t('brokerDetails.actionOption9'),
		value: 'referral-law-enforcement',
	},
	{ text: i18n.global.t('brokerDetails.actionOption10'), value: 'other' },
]
